import React, {Component} from 'react';
import { Link } from 'react-router-dom';

class Statistics extends Component {
  constructor(props) {
    super(props)

    this.renderNewBids = this.renderNewBids.bind(this);
  }

  renderNewBids() {
    return (
      <Link to={{pathname: "/project-finder/search?new_bids_only=true"}}
        data-testid="new-bids-stats-div"
        target="_blank"
      >
        <div className="ds-data _parallelData _alignCenter statistic">
          <h1 className="dataName">{this.props.newBidsCount.toLocaleString()}</h1>
          <p className="data">New Bids Posted</p>
        </div>
      </Link>
    )
  }

  renderOpenBidsValue() {
    return (
      <Link to={{pathname: "/project-finder/search"}}
        data-testid="open-bids-value-stats-div"
        target="_blank"
      >
        <div className="ds-data _parallelData _alignCenter statistic">
          <h1 className="dataName">₱{this.props.openBidsValue}</h1>
          <p className="data">Value of Open Bids</p>
        </div>
      </Link>
    )
  }

  renderOpenBidsCount() {
    return (
      <Link to={{pathname: "/project-finder/search"}}
        data-testid="open-bids-value-stats-div"
        target="_blank"
      >
        <div className="ds-data _parallelData _alignCenter statistic">
          <h1 className="dataName">{this.props.openBidsCount.toLocaleString()}</h1>
          <p className="data">Open Bids</p>
        </div>
      </Link>
    )
  }

  render() {
    return (
      <div className="statistics-container">
        <h1 className="statistics-title"> Today's Project Finder Statistics </h1>
        <div className="statistics-values">
          {this.renderNewBids()}
          {this.renderOpenBidsValue()}
          {this.renderOpenBidsCount()}
        </div>
      </div>
    );
  }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/features/projectFinderLandingPage/components/Statistics.js